import React from "react";
import LocalizedStrings from 'react-localization';
import ProgressIndicator from "react-rainbow-components/components/ProgressIndicator";
import ProgressStep from "react-rainbow-components/components/ProgressStep";
import CustomUploadButton from 'react-firebase-file-uploader/lib/CustomUploadButton';
import Application from "react-rainbow-components/components/Application";
import Colors from '../../constants/Colors'
import axios from 'axios';
import {
  Form,
  Icon,
  TextArea,
  Header,
  Button,
  Dropdown,
  Container,
  Dimmer,
  Loader,
  Grid,
  Card,
  Image,
} from "semantic-ui-react";
import "./styles.css";
import StepOne from "./StepOne";
import RainbowMap from "./Map"
import Autocomplete from "react-google-autocomplete";
import Geocode from "react-geocode";
import firebase from "firebase";
//import FileUploader from "react-firebase-file-uploader";
import "../../../src/firebaseConfig.js";
import restaurant from "./restaurant4.jpg"
const theme = {
  rainbow: {
    palette: {
      brand: Colors.fcPink,
    },
  },
};
const currencyOptions = [
  {
    key: "BGN",
    text: "Български лев",
    value: "BGN",
    flag: "bg"
  },
  {
    key: "EUR",
    text: "Euro",
    value: "EUR",
    flag: "eu"
  }
];
const countryOptions = [
  { key: 'Bulgaria', value: 'Bulgaria', flag: 'bg', text: 'Bulgaria' }]
//const steps = ["first", "second", "third", "fourth", "fifth"];
const stepNames = ["step-1", "step-2", "step-3", "step-4", "step-5"];
const MAX_SIZE = 1e6;

// implement this https://semantic-ui.com/behaviors/form.html#/examples
// state explanations: completed is Submit button clicked, but not yet posted by server , submitted is successfully received by server
//set currentStepIndex:5 in state in order to test submit form functionality without filling it out
export default class ProgressIndicatorWithLabel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStepIndex: 0,
      clicked: false,
      loading: true,
      completed: false,
      submitted: false,
      vendorType: "undefined",
      stepOneCompleted: false,
      stepTwoCompleted: false,
      stepThreeCompleted: false,
      stepFourCompleted: false,
      company_name: "",
      email: "",
      short_description: "",
      contact_name: "",
      website: "",
      avatarURL: "",
      avatar: "",
      logoURL: '',
      logo: '',
      contact_email: "",
      contact_phone: "",
      placeLat: 42.65,
      placeLng: 23.33,
      zoom: 10,
      marker_name: "Your first place",
      marker_description: "Your unique description",
      legal_name: "",
      registered_to: "",
      VAT: "",
      registered_to_country: "",
      registered_to_city: "",
      registered_to_address_line1: "",
      registered_to_address_line2: "",
      registered_to_phone: "",
      registered_to_postcode: "",
      currency: "",
      IBAN: "",
      termsChecked: false,
      isUploading: false,
      disabled: true,
      error: false
    };
    this.handleNextClick = this.handleNextClick.bind(this);
    this.handleBackClick = this.handleBackClick.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  strings = new LocalizedStrings({
    en:{
      step_venue:"Venue",
      step_general_info:"General Information",
      step_business_det:"Business Details",
      step_payment_info:"Payment Information",
      step_terms:"Terms and Conditions",
      header_venue: "What type of venue are you?",
      icon_restaurant: "Restaurant",
      icon_supermarket: "Supermarket",
      icon_caffe: "Caffe",
      icon_producer: "Producer",
      button_back:"Back",
      button_next:"Next",
      header_gen_info:"Company Details",
      company_name:"Company name",
      company_website:"Company website",
      this_is_how:"This is how our customers will see your store",
      input_name:"Name",
      input_website:"Website",
      upload_image:"Upload an image",
      upload_image_text:"Upload an image of your venue",
      upload_logo:"Upload your logo",
      upload_logo_not_m:"* not mandatory",
      input_desc:"Short description",
      input_desc_text:"This description will be shown to clients on our platform. Introduce your business in a couple of sentences and make it stand out!",
      your_first_place:"Your first place",
      your_unique_desc:"Your unique description",
      select_your_location:"Select your location",
      input_text:"Enter a location",
      text_below_location_input:"*If you have multiple venues, just enter the address of one of them and you will be able to add others stores to your profile at a later stage!",
      marker_text_1:"Your first place",
      marker_text_2:"Your unique description",
      input_contact_name_header:"Contact person name",
      input_contact_name_placeholder:"Name",
      input_contact_email_header:"Contact e-mail",
      input_contact_email_placeholder:"Email",
      input_contact_phone_header:"Contact phone",
      input_contact_phone_placeholder:"Phone number",
      header_business_details:"Business Details",
      header_text_below_b_d:"All of the data collected here will be stored securely and will not be shared with anyone on our platform. The data that you provide will only be used for invoices and payments.",
      input_legal_name:"Company legal name",
      input_legal_name_pl:"Legal name",
      input_contact_number:"Contact number",
      input_contact_number_pl:"+359886777666",
      input_registered_to:"Registered to",
      input_registered_to_pl:"Person name",
      input_vat:"VAT",
      input_vat_pl:"8501010123",
      header_company_legal_addr:"Company legal address",
      input_address_1:"Address Line 1",
      input_address_2:"Address Line 2 (optional)",
      input_country:"Country",
      input_city:"City",
      input_postcode:"Postcode",
      header_payment_info:"Payment information",
      header_text_below_p_i:"Payments will be made to this bank account based on the terms and conditions in the next section. Please provide a valid bank account in the currency that you have selected.",
      input_select_currency:"Select currency",
      input_select_currency_dropdowrn:"Select currency",
      input_iban:"IBAN",
      input_iban_placeholder:"BG18RZBB91550123456789",
      header_terms:"Terms and Conditions",
      text_terms:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa strong. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede link mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus. Phasellus viverra nulla ut metus varius laoreet. Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi.",
      agree_checkbox:"I agree to the Terms and Conditions",
      completed_text_1:"Your details have been successfully submitted! We will contact you as soon as your venue has been approved!",
      completed_text_2:"We will contact you as soon as your venue has been approved!",
      error_text:"Something went wrong... Please contact support at support@dontwaste.me !",
      button_submit:"Submit",
    },
    bg: {
      step_venue:"Магазин",
      step_general_info:"Обща информация",
      step_business_det:"Бизнес детайли",
      step_payment_info:"Финансова информация",
      step_terms:"Общи условия",
      header_venue: "Какъв е вашият бизнес?",
      icon_restaurant: "Ресторант",
      icon_supermarket: "Супермаркет",
      icon_caffe: "Кафе",
      icon_producer: "Производител",
      button_back:"Назад",
      button_next:"Напред",
      header_gen_info:"Детайли за Компанията",
      company_name:"Име на Компанията",
      company_website:"Уебсайт на Компанията",
      this_is_how:"Това ще е основната картинка на вашия магазин",
      input_name:"Име",
      input_website:"Уебсайт",
      upload_image:"Качете снимка",
      upload_image_text:"Качете снимка на вашия магазин",
      upload_logo:"Качете лого",
      upload_logo_not_m:"* не е задължително",
      input_desc:"Кратко описание",
      input_desc_text:"Това описание ще се показва на клиентите Ви в платформата. Напишете няколко изречения описващи вашия бизнес!",
      your_first_place:"Вашия първи магазин",
      your_unique_desc:"Вашето уникално описание",
      select_your_location:"Изберете локация",
      input_text:"Изберете локация",
      text_below_location_input:"*Ако имате няколко обекта, напишете адреса на един от тях, останалите ще имате възможност да ги въведете по-късно!",
      marker_text_1:"Добавете първи обект",
      marker_text_2:"Вашето уникално описание",
      input_contact_name_header:"Име на контактно лице",
      input_contact_name_placeholder:"Име",
      input_contact_email_header:"Имейл на контактно лице",
      input_contact_email_placeholder:"Имейл",
      input_contact_phone_header:"Телефон на контактно лице",
      input_contact_phone_placeholder:"Телефон",
      header_business_details:"Бизнес детайли",
      header_text_below_b_d:"Информацията ще се запази сигурно и няма да бъде споделяна с никого. Информацията ще се използва само за фактури и плащания.",
      input_legal_name:"Име на компанията",
      input_legal_name_pl:"Име по регистрация",
      input_contact_number:"Телефон",
      input_contact_number_pl:"+359886777666",
      input_registered_to:"МОЛ",
      input_registered_to_pl:"Име",
      input_vat:"ДДС номер",
      input_vat_pl:"8501010123",
      header_company_legal_addr:"Адрес по регистрация",
      input_address_1:"Адрес 1",
      input_address_2:"Адрес 2 (опция)",
      input_country:"Държава",
      input_city:"Град",
      input_postcode:"Пощенски код",
      header_payment_info:"Финансова информация",
      header_text_below_p_i:"Плащанията ще бъдат насочвани към този адрес съгласно Общите условия по-долу. Моля, въведете валиден банков номер в избраната валута.",
      input_select_currency:"Изберете държава",
      input_select_currency_dropdowrn:"Изберете държава",
      input_iban:"IBAN",
      input_iban_placeholder:"BG18RZBB91550123456789",
      header_terms:"Общи условия и условия за ползване на платформата",
      text_terms:"Примерен текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст",
      agree_checkbox:"Съгласен съм с всички условия",
      completed_text_1:"Вашата информация беше успешно запазена! Ще се свържен с вас когато я обработим и валидираме!",
      completed_text_2:"Ще се свържем с вас когато удобрим кандидатурата ви!",
      error_text:"Нещо се обърка... Моля, свържете се с нас на имейл support@dontwaste.me !",
      button_submit:"Изпрати",
    }
   });

  handleUploadStart = () => this.setState({ isUploading: true });
  handleUploadError = error => {
    this.setState({ isUploading: false });
    console.error(error);
  };
  handleAvatarUploadSuccess = async (filename) => {
    this.setState({ avatar: filename, isUploading: false });
    await firebase
      .storage()
      .ref("images")
      .child(filename)
      .getDownloadURL()
      .then(url => this.setState({ avatarURL: url }));
  };
  //need a different progress state if you want to visualize upload process
  handleLogoUploadSuccess = filename => {
    this.setState({ logo: filename, isUploading: false });
    firebase
      .storage()
      .ref("images")
      .child(filename)
      .getDownloadURL()
      .then(url => this.setState({ logoURL: url }));
  };
  handleSubmit = async (user) => {
    //post data to account id
    const { submitted, loading, error } = this.state;
    const { vendorType, company_name, email, short_description,
      contact_name, website, avatarURL, avatar, logoURL, logo,
      contact_email, contact_phone, legal_name, registered_to, VAT,
      registered_to_country, registered_to_city, registered_to_address_line1, registered_to_address_line2,
      registered_to_phone, registered_to_postcode, currency, IBAN } = this.state;
    // after successfull submit set state]
    // await axios.post("https://api.dontwaste.me/places/", {
    await axios.post("http://localhost:3004/register/", {
      userid: user,
      vendorType: vendorType,
      company_name: company_name,
      email: email,
      short_description: short_description,
      contact_name: contact_name,
      website: website,
      avatarURL: avatarURL,
      avatar: avatar,
      logoURL: logoURL,
      logo: logo,
      contact_email: contact_email,
      contact_phone: contact_phone,
      legal_name: legal_name,
      registered_to: registered_to,
      VAT: VAT,
      registered_to_country: registered_to_country,
      registered_to_city: registered_to_city,
      registered_to_address_line1: registered_to_address_line1,
      registered_to_address_line2: registered_to_address_line2,
      registered_to_phone: registered_to_phone,
      registered_to_postcode: registered_to_postcode,
      currency: currency,
      IBAN: IBAN,
    },
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    )
      .then(res => res.status === 201 ? 
       ( this.setState({ completed: true, loading: false })
      //  this.props.handleFinalSubmit(submitted)
      )
        :
         (this.setState({ completed: true, loading: false, error: true }))
        //  this.props.handleFinalSubmit(submitted)
        )
      .catch(err => {
        console.log(err);
        this.setState({ completed: true, loading: false, error: true })
        // this.props.handleFinalSubmit(submitted);
      });

    console.log("loading", loading);
    console.log("handle submit", submitted);
   
  };

  receiveVendorType = vendorType => {
    this.setState({ vendorType: vendorType });
    this.setState({ stepOneCompleted: true });
  };

  receiveVendorDetails = vendorDetails => {
    //  (this.setState({ name :vendorDetails.name }, console.log('name: ', this.state.name)))
    //( this.setState({ email :vendorDetails.email }, console.log('email: ', this.state.email)))
    // (this.setState({ website :vendorDetails.website }, console.log('website: ', this.state.website)))
    console.log("receive from child:", vendorDetails);
    //(this.state.contact_phone !== '' ? this.setState({stepOneCompleted: true}) : null)
  };
  convertPlaceToGeoCode = place1 => {
    this.setState({ placeAddressByGoogle: place1 });
    console.log(this.state.placeAddressByGoogle);
    Geocode.setApiKey("AIzaSyDfeHv6QM9PqtzE_MM5O_X81ZUjwU_jR0Q");
    Geocode.enableDebug();
    Geocode.fromAddress(place1.formatted_address).then(
      response => {
        const { lat, lng } = response.results[0].geometry.location;
        this.setState({ placeLat: lat, placeLng: lng });
        this.setState({ zoom: 15 });
        console.log(lat, lng);
        //console.log('state.lat= ', this.state.placeLat)
        //console.log('state.lng= ', this.state.placeLng)
      },
      error => {
        console.error(error);
      }
    );
  };

  handleChange = (e, { name, value }) => {
    //this.updateMarker is one state behind....

    this.setState({ [name]: value });

    if (name === "company_name") {
      this.setState(
        { marker_name: value },
        console.log(this.state.marker_name)
      );
    }
    if (name === "short_description") {
      this.setState(
        { marker_description: value },
        console.log(this.state.marker_description)
      );
    }
  };

  handleCurrencyChange = (e, { value }) => {
    this.setState({ currency: value }, console.log(this.state.currency));
  };

  handleTermsChange = () => {
    this.setState(prevState => ({ termsChecked: !prevState.termsChecked }));
    console.log(this.state.termsChecked);
  };

  changeCompleted = () => {
    this.setState({ stepOneCompleted: true });
  };

  handleNextClick() {
    const { currentStepIndex } = this.state;
    if (currentStepIndex < stepNames.length - 1) {
      const nextStepIndex = currentStepIndex + 1;
      //this.setState({ stepOneCompleted: false });
      console.log(this.state);
      return this.setState({ currentStepIndex: nextStepIndex, disabled: true });
    }
    return this.setState({ isNextDisabled: false });
  }

  handleBackClick() {
    const { currentStepIndex } = this.state;
    if (currentStepIndex > 0) {
      const previewStepIndex = currentStepIndex - 1;
      this.setState({ currentStepIndex: previewStepIndex });
    }
  }
  componentDidUpdate() {
    const { currentStepIndex, stepOneCompleted, stepTwoCompleted, stepThreeCompleted, stepFourCompleted } = this.state;
    const {
      contact_email,
      /* contact_name,
      contact_phone,
      short_description,
      website,
      avatarURL,
      company_name,
      isUploading, */
      disabled
    } = this.state;

    const {
      legal_name,
      registered_to,
      VAT,
      registered_to_country,
      registered_to_city,
      registered_to_address_line1,
      /* registered_to_address_line2, */
      registered_to_phone,
      registered_to_postcode
    } = this.state;

    const { currency, IBAN } = this.state;
    console.log("state", this.state)
    // if (isUploading) {
    //   console.log('isUploading,', isUploading)
    //   return false
    // };
    if (
      currentStepIndex === 0 &&
      stepOneCompleted &&
      disabled
    ) {
      this.setState({ disabled: false })
    }
    if (
      currentStepIndex === 1 &&
      stepOneCompleted &&
      !stepTwoCompleted &&
      contact_email !== "" //&&
      // UNCOMMENT!!!
      // contact_name !== "" &&
      // contact_phone !== "" &&
      // short_description !== "" &&
      // website !== "" &&
      // avatarURL !== ""
    ) {
      this.setState({ stepTwoCompleted: true })
    }
    if (
      currentStepIndex === 1 &&
      stepOneCompleted &&
      stepTwoCompleted &&
      disabled
    ) {
      this.setState({ disabled: false })
    }

    if (
      currentStepIndex === 2 &&
      stepOneCompleted &&
      stepTwoCompleted &&
      !stepThreeCompleted &&
      legal_name !== "" &&
      registered_to !== "" &&
      VAT !== "" &&
      registered_to_country !== "" &&
      registered_to_city !== "" &&
      registered_to_address_line1 !== "" &&
      registered_to_phone !== "" &&
      registered_to_postcode !== ""
    ) {
      this.setState({ stepThreeCompleted: true });
    }
    if (
      currentStepIndex === 2 &&
      stepOneCompleted &&
      stepTwoCompleted &&
      stepThreeCompleted &&
      disabled
    ) {
      this.setState({ disabled: false })
    }

    if (
      currentStepIndex === 3 &&
      stepOneCompleted &&
      stepTwoCompleted &&
      stepThreeCompleted &&
      !stepFourCompleted &&
      currency !== "" &&
      IBAN !== ""
    ) {
      this.setState({ stepFourCompleted: true });
    }
    if (
      currentStepIndex === 3 &&
      stepOneCompleted &&
      stepTwoCompleted &&
      stepThreeCompleted &&
      stepFourCompleted &&
      disabled
    ) {
      this.setState({ disabled: false })
    }

  }
  isBackDisabled() {
    const { currentStepIndex } = this.state;
    if (currentStepIndex > 0 && currentStepIndex < stepNames.length) {
      return false;
    }
    return true;
  }

  _setLanguage = (lang) => {
    //console.log(lang)
    this.strings.setLanguage(lang)
  }

  render() {
    const {
      currentStepIndex,
      zoom,
      company_name,
      marker_name,
      marker_description,
      placeLat,
      placeLng,
      contact_email,
      contact_name,
      contact_phone,
      short_description,
      website
    } = this.state;

    const {
      legal_name,
      registered_to,
      VAT,
      registered_to_country,
      registered_to_city,
      registered_to_address_line1,
      registered_to_address_line2,
      registered_to_phone,
      registered_to_postcode
    } = this.state;

    const { IBAN, termsChecked } = this.state;

    const { loading, completed, disabled } = this.state;

    const { avatarURL, logoURL } = this.state;


    return (
              <Container>
                {/* <Application theme={theme}> */}
                {this._setLanguage(this.props.user["https://fc-demo/language"])}
                  {completed ? (
                    <Dimmer.Dimmable
                      as={"div"}
                      blurring
                      dimmed={loading}
                      textAlign="center"
                      inverted
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <Loader active disabled={!loading} />
                      <Dimmer
                        active={loading}
                        onClickOutside={this.handleHide}
                        inverted="true"
                      />
                      <Icon name="checkmark" color="green" size="huge" />
                      {!this.state.error ?
                      <>
                        <Header as="h4">
                          {this.strings.completed_text_1}
                         </Header>
                        <Header as="h4">
                          {this.strings.completed_text_2}
                        </Header>
                        </>
                         :
                        <Header as="h4">
                          {this.strings.error_text}
                        </Header>
                      }
                    </Dimmer.Dimmable>
                  ) : (
                      <Form className="form_container">
                        <div className="rainbow-m-bottom_large rainbow-p-bottom_large">
                          <ProgressIndicator className="progress-indicator" currentStepName={stepNames[currentStepIndex]}>
                            <ProgressStep name="step-1" label={this.strings.step_venue} />
                            <ProgressStep name="step-2" label={this.strings.step_general_info} />
                            <ProgressStep name="step-3" label={this.strings.step_business_det} />
                            <ProgressStep name="step-4" label={this.strings.step_payment_info} />
                            <ProgressStep name="step-5" label={this.strings.step_terms} />
                          </ProgressIndicator>

                          <div style={{ marginTop: "40px" }}>
                            {
                              //put the entire code from step two,three etc here and still use current stepindex, bu wrap
                              //everything in a form component and make a submit button appear when currentstepindex = stepname.len - 1
                            }

                            {currentStepIndex === 0 ? (
                              <StepOne defineVendorType={this.receiveVendorType} header_venue={this.strings.header_venue} icon_restaurant={this.strings.icon_restaurant} icon_supermarket={this.strings.icon_supermarket} icon_caffe={this.strings.icon_caffe} icon_producer={this.strings.icon_producer} />
                            ) : currentStepIndex === 1 ? (
                              <div>
                                <Header
                                  as="h2"
                                  content={this.strings.header_gen_info}
                                  textAlign="center"
                                />
                                <Grid>
                                  {console.log('sstae', this.state)}
                                  <Grid.Column width={10}>
                                    <Form.Group widths="equal">
                                      <Form.Input
                                        placeholder={this.strings.input_name}
                                        label={this.strings.company_name}
                                        name="company_name"
                                        value={company_name}
                                        onChange={this.handleChange}
                                        required
                                        iconPosition="left"
                                        icon="user circle"
                                      />

                                      <Form.Input
                                        label={this.strings.company_website}
                                        placeholder={this.strings.input_website}
                                        name="website"
                                        value={website}
                                        onChange={this.handleChange}
                                        iconPosition="left"
                                        icon="at"
                                      />

                                    </Form.Group>
                                    <Header as="h5" content={this.strings.upload_image} />
                                    <Form.Group widths="equal">
                                      <CustomUploadButton
                                        className="upload_button"
                                        style={{ marginLeft: '2rem', marginRight: '2rem', backgroundColor: '#99D68F', color: 'white', padding: 10, borderRadius: 4, fontSize: '1rem', fontWeight: 'bold' }}
                                        required
                                        accept="image/*"
                                        name="avatar"
                                        randomizeFilename
                                        storageRef={firebase.storage().ref("images")}
                                        beforeUploadStart={file => { if (file.size > MAX_SIZE) throw Error('File too large') }}
                                        onUploadStart={this.handleUploadStart}
                                        onUploadError={this.handleUploadError}
                                        onUploadSuccess={this.handleAvatarUploadSuccess}
                                        metadata={{ cacheControl: 'max-age=3600' }}
                                      >
                                        {this.strings.upload_image_text}
                          </CustomUploadButton>
                                      <CustomUploadButton
                                        className="upload_button"
                                        style={{ marginLeft: '2rem', marginRight: '2rem', backgroundColor: '#99D68F', color: 'white', padding: 10, borderRadius: 4, fontSize: '1rem', fontWeight: 'bold' }}
                                        required
                                        accept="image/*"
                                        name="avatar"
                                        randomizeFilename
                                        storageRef={firebase.storage().ref("images")}
                                        beforeUploadStart={file => { if (file.size > MAX_SIZE) throw Error('File too large') }}
                                        onUploadStart={this.handleUploadStart}
                                        onUploadError={this.handleUploadError}
                                        onUploadSuccess={this.handleLogoUploadSuccess}
                                        metadata={{ cacheControl: 'max-age=3600' }}
                                      >
                                        {this.strings.upload_logo}
                          <p style={{ fontSize: 8 }}>{this.strings.upload_logo_not_m}</p>
                                      </CustomUploadButton>
                                    </Form.Group>
                                    <Form.Field
                                      width="16"
                                      name="short_description"
                                      required
                                      control={TextArea}
                                      value={short_description}
                                      onChange={this.handleChange}
                                      label={this.strings.input_desc}
                                      placeholder={this.strings.input_desc_text}
                                    />
                                  </Grid.Column>
                                  <Grid.Column width={6}>
                                    <Header as="h4" content={this.strings.this_is_how} />
                                    <Card>
                                      <Image src={avatarURL !== '' ? avatarURL : restaurant} />
                                      <Card.Content>
                                        <Card.Header>
                                          {logoURL !== '' ?
                                            (<Image src={logoURL} size="mini" style={{ paddingTop: "0.1em", float: 'right' }} />
                                            )
                                            : null}
                                          {marker_name}
                                        </Card.Header>
                                        <Card.Description>
                                          {marker_description}
                                        </Card.Description>
                                      </Card.Content>
                                    </Card>
                                  </Grid.Column>
                                </Grid>
                                <Header as="h5" content={this.strings.select_your_location} />
                                <Autocomplete
                                  style={{ width: "100%", marginBottom: "1em" }}
                                  onPlaceSelected={place1 => {
                                    this.convertPlaceToGeoCode(place1);
                                  }}
                                  types={["establishment"]}
                                  componentRestrictions={{ country: "bg" }}
                                />
                                <p>{this.strings.text_below_location_input}</p>
                                <RainbowMap
                                  latitude={placeLat}
                                  longitude={placeLng}
                                  label={this.state.marker_name}
                                  description={this.state.marker_description}
                                  zoom={zoom}
                                />
                                <Form.Group widths="equal" style={{ marginTop: "20px" }}>
                                  <Form.Input
                                    placeholder={this.strings.input_contact_name_placeholder}
                                    label={this.strings.input_contact_name_header}
                                    name="contact_name"
                                    value={contact_name}
                                    onChange={this.handleChange}
                                    required
                                    iconPosition="left"
                                    icon="user"
                                    color="red"
                                  />
                                  <Form.Input
                                    placeholder={this.strings.input_contact_email_placeholder}
                                    label={this.strings.input_contact_email_header}
                                    name="contact_email"
                                    value={contact_email}
                                    onChange={this.handleChange}
                                    required
                                    iconPosition="left"
                                    icon="mail"
                                  />
                                  <Form.Input
                                    placeholder={this.strings.input_contact_phone_placeholder}
                                    label={this.strings.input_contact_phone_header}
                                    name="contact_phone"
                                    value={contact_phone}
                                    onChange={this.handleChange}
                                    required
                                    iconPosition="left"
                                    icon="phone"
                                  />
                                </Form.Group>
                              </div>
                            ) : currentStepIndex === 2 ? (
                              <div>
                                <Header as="h2" textAlign="center">
                                  <Header.Content>{this.strings.header_business_details}</Header.Content>
                                  <Header.Subheader style={{ maxWidth: "600px" }}>
                                    {this.strings.header_text_below_b_d}
                      </Header.Subheader>
                                </Header>
                                <Form.Group widths="equal">
                                  <Form.Input
                                    placeholder={this.strings.input_legal_name_pl}
                                    label={this.strings.input_legal_name}
                                    name="legal_name"
                                    value={legal_name}
                                    onChange={this.handleChange}
                                    required
                                  />
                                  <Form.Input
                                    placeholder={this.strings.input_contact_number_pl}
                                    label={this.strings.input_contact_number}
                                    name="registered_to_phone"
                                    value={registered_to_phone}
                                    onChange={this.handleChange}
                                    required
                                  />
                                </Form.Group>
                                <Form.Group widths="equal">
                                  <Form.Input
                                    label={this.strings.registered_to}
                                    placeholder={this.strings.input_registered_to_pl}
                                    name="registered_to"
                                    value={registered_to}
                                    onChange={this.handleChange}
                                    required
                                  />
                                  <Form.Input
                                    label={this.strings.input_vat}
                                    placeholder={this.strings.input_vat_pl}
                                    name="VAT"
                                    value={VAT}
                                    onChange={this.handleChange}
                                    required
                                  />
                                </Form.Group>

                                <Header as="h3" content={this.strings.header_company_legal_addr} />
                                <Form.Group>
                                  <Form.Input
                                    label={this.strings.input_address_1}
                                    name="registered_to_address_line1"
                                    value={registered_to_address_line1}
                                    onChange={this.handleChange}
                                    required
                                  />
                                  <Form.Input
                                    label={this.strings.input_address_2}
                                    name="registered_to_address_line2"
                                    value={registered_to_address_line2}
                                    onChange={this.handleChange}

                                  />
                                </Form.Group>
                                <Form.Group>
                                  <Form.Dropdown
                                    width="6"
                                    label={this.strings.input_country}
                                    options={countryOptions}
                                    name="registered_to_country"
                                    search
                                    selection
                                    //value={registered_to_country}
                                    onChange={this.handleChange}
                                    required />
                                  <Form.Input
                                    width="6"
                                    label={this.strings.input_city}
                                    name="registered_to_city"
                                    value={registered_to_city}
                                    onChange={this.handleChange}
                                    required
                                  />
                                  <Form.Input
                                    width="4"
                                    label={this.strings.input_postcode}
                                    name="registered_to_postcode"
                                    value={registered_to_postcode}
                                    onChange={this.handleChange}
                                    required
                                  />
                                </Form.Group>
                              </div>
                            ) : currentStepIndex === 3 ? (
                              <div>
                                <Header as="h2" textAlign="center">
                                  <Header.Content>{this.strings.header_payment_info}</Header.Content>
                                  <Header.Subheader style={{ maxWidth: "600px" }}>
                                    {this.strings.header_text_below_p_i}
                      </Header.Subheader>
                                </Header>
                                <Form.Field
                                  onChange={this.handleCurrencyChange}
                                  closeOnChange
                                  label={this.strings.input_select_currency}
                                  name="currency"
                                  inline
                                  control={Dropdown}
                                  placeholder={this.strings.input_select_currency_dropdowrn}
                                  selection
                                  options={currencyOptions}
                                />
                                {
                                  // we can render different iban/ sort-code etc for different countries
                                }
                                <Form.Group widths="equal">
                                  <Form.Input
                                    placeholder="BG18RZBB91550123456789"
                                    label="IBAN"
                                    name="IBAN"
                                    value={IBAN}
                                    onChange={this.handleChange}
                                    required
                                  />
                                </Form.Group>
                              </div>
                            ) : (
                                      <>
                                        <Container
                                          text
                                          style={{
                                            overflow: "auto",
                                            maxHeight: "30em",
                                            marginTop: "2em"
                                          }}
                                        >
                                          <Header as="h2" textAlign="center">
                                            {this.strings.header_terms}
                      </Header>
                                          <p>
                                            {this.strings.text_terms}
                                          </p>
                                        </Container>
                                        <Form.Checkbox
                                          required
                                          label={this.strings.agree_checkbox}
                                          checked={termsChecked}
                                          onChange={this.handleTermsChange}
                                          className="checkbox_form"
                                        />
                                      </>
                                    )}
                          </div>
                          <div className="rainbow-m-top_xx-large rainbow-align-content_center rainbow-flex_wrap">
                            <Button
                              style={{ marginRight: "2em" }}
                              basic
                              color="grey"
                              onClick={this.handleBackClick}
                              disabled={this.isBackDisabled()}
                              className="rainbow-m-horizontal_medium"
                            >
                              {this.strings.button_back}
                </Button>
                            {currentStepIndex < stepNames.length - 1 ? (
                              <Button
                                basic
                                color="green"
                                onClick={this.handleNextClick}
                                disabled={disabled}
                                className="rainbow-m-horizontal_medium"
                              >
                                {this.strings.button_next}
                              </Button>
                            ) : (
                                <Button
                                  color="green"
                                  onClick={() => this.handleSubmit(this.props.user)}
                                  disabled={!termsChecked}
                                  className="rainbow-m-horizontal_medium"
                                >
                                  {this.strings.button_submit}
                                </Button>
                              )}
                          </div>
                        </div>
                      </Form>
                    )}
                {/*</Application>*/}
              </Container>
              
    )
  }
}
